import { render, staticRenderFns } from "./PostInfo.vue?vue&type=template&id=424e60a6&scoped=true"
import script from "./PostInfo.vue?vue&type=script&lang=js"
export * from "./PostInfo.vue?vue&type=script&lang=js"
import style0 from "./PostInfo.vue?vue&type=style&index=0&id=424e60a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e60a6",
  null
  
)

export default component.exports